import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactGA from 'react-ga4';

// Initialize Google Analytics with your Measurement ID
ReactGA.initialize('G-YBDEVBLLTJ');

// Custom function to send performance metrics to Google Analytics
const sendToAnalytics = ({ name, delta, id }) => {
  ReactGA.event({
    category: 'Web Vitals',
    action: name,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    label: id,
    nonInteraction: true,
  });
};

// Modified reportWebVitals to send data to Google Analytics
const enhancedReportWebVitals = () => {
  reportWebVitals(sendToAnalytics);
};

// Custom Analytics wrapper component
const AppWithAnalytics = () => {
  useEffect(() => {
    // Send initial pageview
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, []);

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithAnalytics />
  </React.StrictMode>
);

// Report web vitals with analytics integration
enhancedReportWebVitals();